






import { Vue, Component, Prop } from 'vue-property-decorator'
import { BlogTag } from '../models/blog-tag'

@Component
export default class BlogTagChip extends Vue {
  @Prop() isLight!: boolean
  @Prop() blogTag!: BlogTag

  get style () {
    return {
      'background-color': this.blogTag.background,
      color: this.blogTag.textColor
    }
  }
}
